// extracted by mini-css-extract-plugin
export default {"scoresContainer":"Scores_scoresContainer__ufFj3","scoresHeader":"Scores_scoresHeader__uyI9q","scoresContent":"Scores_scoresContent__LotPb"};